import { FC } from 'react';

import Paragraph from '@/components/text/Paragraph.tsx';

import { useCalendarStore } from '@/stores/calendarStore.ts';

import { BASE_HEADER_HEIGHT } from '@/utils/calendarUtils.ts';

interface Props {
    timeSlotHeight: number;
    timeSlots: { time: string }[];
}

const Timeline: FC<Props> = ({ timeSlotHeight, timeSlots }) => {
    const header_height = useCalendarStore((state) => state.header_height);
    return (
        <div className="bg-red sticky left-0 z-10 h-full w-[50px] border-r border-slate-200">
            <div
                className="sticky top-0 z-10 w-full bg-white"
                style={{ height: header_height ? `${header_height}px` : BASE_HEADER_HEIGHT }}
            />
            {timeSlots.map((slot) => (
                <div
                    key={slot.time}
                    className="flex flex-col border-t border-slate-200 last:border-b last:border-slate-200"
                    style={{ height: timeSlotHeight }}
                >
                    <Paragraph className="mr-4 flex text-xs text-slate-500">{slot.time}</Paragraph>
                </div>
            ))}
        </div>
    );
};

export default Timeline;
